import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LoadingPage } from 'app/shared/components/loading/loading.page.component';
import { read } from 'fs';

@Component({
  selector: 'itpx-card-stack-presentation',
  templateUrl: './card-stack-presentation.component.html',
  styleUrls: ['./card-stack-presentation.component.css']
})
export class CardStackPresentationComponent implements OnInit {
  @Input() cards: any[];
  @Input() emptyConfig: any;
  @Output() stateChange$ = new EventEmitter<string>();
  @Input() cardsLength: number;
  @Input() currentPage: number;
  @Output() pageChanged = new EventEmitter<number>();

  constructor() { }

  ngOnInit() {
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

  onStateChange(event: string) {
    this.stateChange$.emit(event);
  }
  onPageChange(e) {
    this.pageChanged.emit(e);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/common/card-stack-presentation/card-stack-presentation.component.ts